import { TaskStatus } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const TASK_STATUS_ICON: Record<TaskStatus, NoddiIconName> = {
  [TaskStatus.PENDING]: 'Target',
  [TaskStatus.IN_PROGRESS]: 'Activity',
  [TaskStatus.COMPLETED]: 'ListCheck',
  [TaskStatus.UNABLE_TO_COMPLETE]: 'Frown'
};
